module.exports = __webpack_public_path__ + "static/media/logo.c0dd65a5.png";